import router from './router'
import store from './store'
// import { Notification } from 'element-ui'
import setting from '@/config/setting'

router.beforeEach(async (to, from, next) => {
  // 当前未保存token
  let token = store.state.commom.token
  let urlToken = to.query.token
  let moodleToken = to.query.mdltoken
  // 如果携带token参数则直接存本地，
  // 如果是从moodle登录页重定向过来则拿到moodleToken获取token
  // 优先级：token>moodleToken>本地存储的token
  if (urlToken) {
    delete to.query.token
    token = urlToken
    store.commit('commom/setToken', token)
    if (to.path.indexOf('login') > -1) {
      return next({ path: '/' })
    } else {
      return next({ path: to.path, query: { ...to.query } })
    }
  } else if (moodleToken) {
    try {
      let tokenResult = await store.dispatch('commom/refreshToken', { token: moodleToken })
      delete to.query.mdltoken
      token = tokenResult.data.token
      store.commit('commom/setToken', token)
      return next({ path: to.path, query: { ...to.query } })
    } catch (error) {
      console.log('refreshToken error', error);
    }
  }
  if (token) {
    try {
      let res = await store
        .dispatch('commom/getUserInfo')
      if (res.code === 1) {
        store.commit('commom/setUserInfo', res.data)
        let roleRes = await store
          .dispatch('commom/getRole')
        if (roleRes.code === 1) {
          store.commit('commom/setRoleList', roleRes.data)
        }
      } else {
        throw new Error()
      }
      return next()
    } catch (error) {
      console.log('error', error);
    }
  }
  window.location.href = setting.callbackUrl
  next()
})
